import React, { Component } from 'react';
import { Trans } from '@lingui/macro';

import Row from '../../../components/Row';
import { Typography, Button, TextInput } from 'components';

import InputValidation from '../../../utils/InputValidation';

class MedicalRequest extends Component {
  state = {
    disableBtn: true,
    picture: {
      placeHolder: 'Selecionar arquivo',
      value: '',
      isValid: true,
      message: '',
    },
  }

  handleSubmit = () => {
    this.setState({ disableBtn: true });
    alert(this.state.picture.value);
  }

  handlePictureInput = async(e) => {
    let getFile = e.target.files;
    let imgName = getFile[0] ? getFile[0].name : 'Selecionar arquivo';

    let validation = new InputValidation(getFile, 'image');
    let imageIsValid = await validation.validate();

    this.setState({
      disableBtn: false,
      picture: {
        placeHolder: imgName,
        value: imageIsValid.encodedImage,
        isValid: imageIsValid.success,
        message: imageIsValid.message,
      },
    });
  }

  render() {
    const { disableBtn, picture } = this.state;

    return (
      <div className="CheckoutPlans">
        <div className="CheckoutPlans__header">
          <Row align='center' justify='center' margin='2rem 0 0.5rem'>
            <Typography
              align='center'
              style={{ width: '100%' }}
              type='title'>
              <Trans>Detalhes do agendamento</Trans>
            </Typography>
          </Row>

          <Row align='center' justify='center' margin='0 0 2rem'>
            <Typography
              align='center'
              color="grey-dark"
              style={{ width: '100%' }}
              type='paragraph'>
              <Trans>Passo 2 de 2</Trans>
            </Typography>
          </Row>
        </div>

        <div className="CheckoutPlans__content">
          <div className="MedicalRequest">
            <Typography gutterBotton>
              Anexe uma foto do seu pedido médico:
            </Typography>

            <div className="MedicalRequest--image-wrapper">
              <TextInput
                addIcon
                iconProps={{
                  name: 'Clip',
                  fill: '#dedede',
                  height: '24px',
                  width: '24px',
                }}
                hasError={!picture.isValid}
                messageError={picture.message}
                name="picture"
                placeholder={picture.placeHolder}
              />
              <input
                id="hiddenInput-file"
                type='file'
                onChange={(e) => this.handlePictureInput(e)}
              />
            </div>

            <Button
              text="finalizar agendamento"
              disabled={disableBtn}
              onButtonClick={() => this.handleSubmit()}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MedicalRequest;